import React from 'react';
import withStyles from '@mui/styles/withStyles';
import mail_icon from '../../assets/images/mail_icon.svg';
import phone_icon from '../../assets/images/phone_icon.svg';
import arrow from '../../assets/images/down_arrow.svg'

const Contact = ({ trainer}) => {
  if (!trainer) return '';

  return (
    <div className="contact">
      <div className='contact-group'>
        <div className='contact-title'>Kontakt</div>
        <img
          src={arrow}
        />
      </div>
      <div>
        <div className='contact-item'>
          <img
            src={mail_icon}
            alt="Mail"
            style={{alignSelf: 'center'}}
          />
          <div
            className="contact-details">
            {trainer.email}
          </div>
        </div>
        <div className='contact-divider'></div>
        <div className='contact-item'>
          <img
            src={phone_icon}
            alt="Phone"
            style={{alignSelf: 'center'}}
          />
          <div
            className="contact-details">
            {trainer.phone}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
